<template>
  <div id="po_full" class="container">
    <div class="actions exclude-print">
      <button
        v-if="isEditing"
        @click="submitOrderItems"
        class="btn-submit"
        :disabled="isSubmitting"
      >
        {{ isSubmitting ? "Saving..." : "Submit Changes" }}</button
      >.
      <button @click="toggleEditMode" class="btn-edit">
        {{ isEditing ? "Cancel Edit" : "Edit Order Items" }}</button
      >.
      <button
        v-if="!isEditing"
        @click="print_fn('po_full', s_po_number + 'p_order')"
        class="btn-submit"
        :disabled="isSubmitting"
      >
        Print</button
      >.
    </div>
    <h2 class="page-title">Purchase Order #{{ s_id }}</h2>

    <div class="order-info">
      <p><strong>Order Number:</strong> {{ s_po_number }}</p>
      <p><strong>Supplier:</strong> {{ s_supplier_name }}</p>
      <p><strong>Date:</strong> {{ s_order_date }}</p>
      <p><strong>Status:</strong> {{ s_status }}</p>
    </div>

    <h3 class="section-title">Order Items</h3>

    <table class="order-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Item Name</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Amount</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in order.items" :key="item.id">
          <td style="padding: 0.2rem 0.3rem">{{ index + 1 }}</td>
          <td style="padding: 0.2rem 0.3rem">{{ item.item_name }}</td>

          <td style="padding: 0.2rem 0.3rem" v-if="isEditing">
            <input
              type="number"
              v-model.number="item.quantity"
              @input="updateAmount(item)"
              class="table-input"
            />
          </td>
          <td style="padding: 0.2rem 0.3rem" v-else>{{ item.quantity }}</td>

          <td style="padding: 0.2rem 0.3rem" v-if="isEditing">
            <input
              type="number"
              v-model.number="item.unit_price"
              @input="updateAmount(item)"
              class="table-input"
            />
          </td>
          <td style="padding: 0.2rem 0.3rem" v-else>
            {{ formatCurrency(item.unit_price) }}
          </td>

          <td style="padding: 0.2rem 0.3rem">
            {{ formatCurrency(item.amount) }}
          </td>

          <td style="padding: 0.2rem 0.3rem" v-if="isEditing">
            <input type="text" v-model="item.description" class="table-input" />
          </td>
          <td style="padding: 0.2rem 0.3rem" v-else>{{ item.description }}</td>
        </tr>
      </tbody>
    </table>
    <!--  -->
    <!-- Total Amount Section -->
    <div class="total-section actions">
      <p><strong>Total Amount:</strong> {{ formatCurrency(totalAmount) }}</p>
    </div>
    <!--  -->
  </div>
</template>

<script>
import { generalApiRequest } from "@/api/apiIndex";
import printPDF from "../../prints/div_to_pdf";

export default {
  name: "PurchaseOrderDetails",
  data() {
    return {
      order: {
        id: "",
        order_number: "",
        supplier_name: "",
        order_date: "",
        status: "",
        items: [],
      },

      s_po_number: "",
      s_supplier_name: "",
      s_order_date: "",
      s_status: "",
      s_id: "",

      isEditing: false,
      isSubmitting: false,
    };
  },
  computed: {
    totalAmount() {
      return this.order.items.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );
    },
  },
  methods: {
    print_fn(div_id, doc_name) {
      return printPDF(div_id, doc_name);
    },
    async fetchOrderDetails() {
      const orderId = this.$route.params.orderID;
      const res = await generalApiRequest(
        `inventory/purchase-orders/show/${orderId}`,
        "GET",
        {},
        1
      );
      this.order = res;
      //   console.log(res);
      this.s_po_number = res.order.po_number;
      this.s_supplier_name = res.order.supplier_name;
      this.s_order_date = res.order.order_date;
      this.s_status = res.order.status;
      this.s_id = res.order.id;
    },
    toggleEditMode() {
      this.isEditing = !this.isEditing;
      // Optionally reload if canceling edit to discard changes
      if (!this.isEditing) {
        this.fetchOrderDetails();
      }
    },
    updateAmount(item) {
      item.amount = item.quantity * item.unit_price;
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat("en-KE", {
        style: "currency",
        currency: "KES",
      }).format(amount);
    },
    async submitOrderItems() {
      this.isSubmitting = true;
      try {
        // Adjust endpoint & payload based on your API requirements
        const payload = {
          items: this.order.items.map(
            ({ id, quantity, unit_price, description, amount }) => ({
              id,
              quantity,
              unit_price,
              description,
              amount,
            })
          ),
        };

        console.log(payload);

        await generalApiRequest(
          `inventory/purchase-orders/update-items/${this.order.id}`,
          "POST",
          payload,
          1
        );

        this.isEditing = false;
        await this.fetchOrderDetails();
        alert("Order items updated successfully.");
      } catch (error) {
        alert("Failed to update order items. Please try again.");
        console.error(error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
  mounted() {
    this.fetchOrderDetails();
  },
};
</script>

<style scoped>
.container {
  max-width: 960px;
  margin: 20px auto;
  padding: 0 20px;
  border: 1px solid black;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.total-section {
  text-align: right;
  font-size: 18px;
  margin: 10px 0 20px;
  padding-right: 5px;
}

.page-title {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 20px;
}

.order-info p {
  margin: 4px 0;
  font-size: 15px;
}

.section-title {
  font-size: 20px;
  font-weight: 500;
  margin: 20px 0 10px;
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
}

.order-table th,
.order-table td {
  border: 1px solid #ccc;
  padding: 10px 8px;
  text-align: left;
  font-size: 14px;
}

.order-table th {
  background-color: #f2f2f2;
}

.order-table td:nth-child(3),
.order-table td:nth-child(4),
.order-table td:nth-child(5) {
  text-align: right;
}

.actions {
  /* margin-bottom: 20px; */
  text-align: right;
  margin-bottom: 1rem;
}

.btn-edit {
  padding: 8px 16px;
  background-color: #0077cc;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-edit:hover {
  background-color: #005fa3;
}

.table-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
  box-sizing: border-box;
}

.btn-submit {
  padding: 8px 16px;
  margin-left: 10px;
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-submit:disabled {
  background-color: #94d3a2;
  cursor: not-allowed;
}
</style>
